import React from 'react';

export const PLANO_BASICO = (
  <>
    O anúncio permanece publicado até a venda do veículo.
    <br />
    <strong>Atenção:</strong> será necessário que o cliente faça a reativação do anúncio, de forma
    gratuita, acessando a área logada a cada 90 dias. Caso contrário, o anúncio será desativado
    automaticamente para evitar que veículos vendidos continuem publicados no site.
  </>
);

export const PLANO_ESSENCIAL = (
  <>
    O anúncio permanece publicado até a venda do veículo.
    <br />
    <strong>Atenção:</strong> será necessário que o cliente faça a reativação do anúncio, de forma
    gratuita, acessando a área logada a cada 90 dias. Caso contrário, o anúncio será desativado
    automaticamente para evitar que veículos vendidos continuem publicados no site.
    Médio destaque para o anúncio.
  </>
);

export const PLANO_PREMIUM = (
  <>
    O anúncio permanece publicado até a venda do veículo.
    <br />
    <strong>Atenção:</strong> será necessário que o cliente faça a reativação do anúncio, de forma
    gratuita, acessando a área logada a cada 90 dias. Caso contrário, o anúncio será desativado
    automaticamente para evitar que veículos vendidos continuem publicados no site.
    Maior destaque para o anúncio.
  </>
);